export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9510.cfa0c7c3.jpg";